import React, { Component } from 'react';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';
import { toast, ToastContainer, Zoom } from 'react-toastify';
import { apiEndPoints, TOAST_CONTAINER_AUTO_CLOSE_TIME_IN_MILLISECONDS } from '../../common/globalConstants';
import http from '../../common/http';
import {
  PARAM_NAME_NEW_PASSWORD,
  PARAM_NAME_RE_ENTERED_NEW_PASSWORD,
} from '../home/components/constants/ChangePasswordConstants';
import { t } from 'i18next';
import qs from 'qs';
import {
  RESET_PASSWORD_I18N_PREFIX as MY_I18N_PREFIX,
  RESET_PASSWORD_I18N_KEYS as MY_I18N_KEYS,
} from './constants/i18n/resetPasswordi18nConstants';
import { getLoginRedirectUrl } from '../home/sharedFunctions';
import PropTypes from 'prop-types';
import {
  BLANK_SPACE,
  CONFIRM_PASSWORD_FORM_FIELD_NAME, INVALID_TOKEN_HEADER_ERROR_VALUE,
  NEW_PASSWORD_FORM_FIELD_NAME,
  PASSWORD_FORM_FIELD_TYPE,
  TEXT_FORM_FIELD_TYPE,
} from './constants/resetPasswordConstants';

const initialState = {
  newPassword: '',
  confirmPassword: '',
};
const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,20}$/;
class ResetPasswordForm extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      error: {},
      formFieldType: PASSWORD_FORM_FIELD_TYPE,
      formFieldNew: PASSWORD_FORM_FIELD_TYPE,
      formFieldConfirm: PASSWORD_FORM_FIELD_TYPE,
      passwordData: JSON.parse(JSON.stringify(initialState)),
      isPasswordChanging: false,
      resetToken: null,
    };
  }

  componentDidMount() {
      const parsed = qs.parse(window.location.search, { ignoreQueryPrefix: true });
      if (! parsed.token) {
          this.props.history.push(getLoginRedirectUrl());
      }
      this.setState({resetToken: parsed.token});
  }

  getI18nText(textKey) {
    return t(MY_I18N_PREFIX + "." + textKey);
  }

  validatePasswords = () => {
      this.validateNewPassword();
      this.validateConfirmPassword();
  };

  validateNewPassword = () => {
    let { error, passwordData } = this.state;

    if (!passwordRegex.test(passwordData.newPassword)) {
      error[NEW_PASSWORD_FORM_FIELD_NAME] = true;
      this.setState({ error });
    }
  }

  validateConfirmPassword = () => {
    let { error, passwordData } = this.state;

    if (passwordData.newPassword && passwordData.newPassword !== passwordData.confirmPassword) {
      error[CONFIRM_PASSWORD_FORM_FIELD_NAME] = true;
      this.setState({ error });
    }
  }

  setFormValues = event => {
    let { passwordData, error } = this.state;
    passwordData[event.target.name] = event.target.value;
    delete error[event.target.name];
    this.setState({
      passwordData,
      error,
    });
  };

  validateForm = form => {
    this.validatePasswords();
    if (
      !form.newPassword ||
      !form.confirmPassword ||
      Object.keys(this.state.error).length > 0
    ) {
      this.setState({
        isPasswordChanging: false,
      });
      return false;
    } else {
      return true;
    }
  };

  ResetPassword = () => {
    const { passwordData, resetToken } = this.state;
    this.setState({
      isPasswordChanging: true,
    });
    if (!this.validateForm(passwordData)) return false;

    const url = `${apiEndPoints.authentication.RESET_PASSWORD}`;
    const params = new URLSearchParams();
    params.append(PARAM_NAME_NEW_PASSWORD, passwordData.newPassword);
    params.append(PARAM_NAME_RE_ENTERED_NEW_PASSWORD,passwordData.confirmPassword);
    params.append('resetToken',resetToken);
    const doRequest = http.post(url, params);
    doRequest.then(
      response => {
          toast.success(this.getI18nText(MY_I18N_KEYS.password_reset_successfully));
          this.setState({ isPasswordChanging: false });

          setTimeout(() => {
              this.props.history.push(getLoginRedirectUrl());
          }, TOAST_CONTAINER_AUTO_CLOSE_TIME_IN_MILLISECONDS);
      },
      error => {
        if (error.response && error.response.data.error && error.response.data.error === INVALID_TOKEN_HEADER_ERROR_VALUE) {
            toast.error(this.getI18nText(MY_I18N_KEYS.reset_token_error));
        }
        else {
            toast.error(this.getI18nText(MY_I18N_KEYS.unknown_error_when_resetting_password));
        }
        this.setState({ isPasswordChanging: false, });
      },
    );
  };


  render() {
    const {
      passwordData,
      error,
      formFieldType,
      formFieldConfirm,
      isPasswordChanging,
    } = this.state;

    return (
      <div className="reset-password-container">
        <ToastContainer
          position="top-center"
          autoClose={TOAST_CONTAINER_AUTO_CLOSE_TIME_IN_MILLISECONDS}
          hideProgressBar
          newestOnTop
          closeOnClick
          transition={Zoom}
          rtl={false}
          pauseOnVisibilityChange
          draggable={false}
          pauseOnHover={false}
        />
        <div className="col-6 reset-password-first-div"></div>
        <div className="col-6 reset-password-div">
          <div className="row">
            <form>
              <h4 className="reset-password-form-title">{this.getI18nText(MY_I18N_KEYS.title)}</h4>
              <div className={'form-group'}>
                <label className="col-form-label">{this.getI18nText(MY_I18N_KEYS.new_password)}</label>
                <div>
                  <input
                    type={formFieldType}
                    name={NEW_PASSWORD_FORM_FIELD_NAME}
                    onChange={e => this.setFormValues(e)}
                    onBlur={this.validateNewPassword}
                    defaultValue={passwordData.newPassword}
                    className={`form-control input ${error && error.newPassword ? 'input-error' : ''
                    }`}
                  />
                  <button
                    type="button"
                    className={`la ${formFieldType === PASSWORD_FORM_FIELD_TYPE ? 'la-eye' : 'la-eye-slash'}`}
                    onClick={() =>
                      this.setState(prevState => {
                        return {
                          formFieldType:
                            prevState.formFieldType === PASSWORD_FORM_FIELD_TYPE ? TEXT_FORM_FIELD_TYPE : PASSWORD_FORM_FIELD_TYPE,
                        };
                      })
                    }
                  ></button>
                </div>
              </div>
              <div className="password-requirements-error-message">
                {error && error.newPassword ? this.getI18nText(MY_I18N_KEYS.password_does_not_meet_requirements) : BLANK_SPACE}
              </div>
              <div className={"password-requirements-spacer-div"}></div>
              <div className={'form-group'}>
                <label className="col-form-label">{this.getI18nText(MY_I18N_KEYS.re_enter_new_password)}</label>
                <div>
                  <input
                    type={formFieldConfirm}
                    className={`form-control input ${
                      error && error.confirmPassword ? 'input-error' : ''
                    }`}
                    onBlur={this.validatePasswords}
                    defaultValue={passwordData.confirmPassword}
                    name={CONFIRM_PASSWORD_FORM_FIELD_NAME}
                    onChange={e => this.setFormValues(e)}
                  />
                  {error.confirmPassword}
                  <button
                    type="button"
                    className={`la ${formFieldConfirm === PASSWORD_FORM_FIELD_TYPE ? 'la-eye' : 'la-eye-slash'}`}
                    onClick={() =>
                      this.setState(prevState => {
                        return {
                          formFieldConfirm:
                            prevState.formFieldConfirm === PASSWORD_FORM_FIELD_TYPE ? TEXT_FORM_FIELD_TYPE : PASSWORD_FORM_FIELD_TYPE,
                        };
                      })
                    }
                  ></button>
                </div>
              </div>
              <div className="message msg-error password-mismatch-error-div">
                  {error && error.confirmPassword ? this.getI18nText(MY_I18N_KEYS.password_mismatch) : BLANK_SPACE}
              </div>
              <div className="password-requirements-spacer-div-2">
                {BLANK_SPACE}
              </div>
              <p
                className={`password-requirements-message ${error && error.confirmPassword ? 'msg-error' : ''}`}>
                {this.getI18nText(MY_I18N_KEYS.password_does_not_meet_requirements)}
              </p>
              <div>
                <br />
                <button
                  type="button"
                  className={`btn reset-password-button btn-primary ${isPasswordChanging && 'disabled'}`}
                  onClick={() => this.ResetPassword()}
                >
                  {isPasswordChanging && <i className="la la-spinner la-spin" />}{this.getI18nText(MY_I18N_KEYS.submit)}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const ResetPassword = compose(withRouter)(ResetPasswordForm);
export default ResetPassword;



// WEBPACK FOOTER //
// ./src/features/login/ResetPassword.js